import { render, staticRenderFns } from "./ClinicRegularVideoCard.vue?vue&type=template&id=4611d88d&scoped=true"
import script from "./ClinicRegularVideoCard.vue?vue&type=script&lang=js"
export * from "./ClinicRegularVideoCard.vue?vue&type=script&lang=js"
import style0 from "./ClinicRegularVideoCard.vue?vue&type=style&index=0&id=4611d88d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4611d88d",
  null
  
)

export default component.exports